module.exports = __webpack_public_path__ + "static/img/kx1-2.9d7162f.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/kx1-2.png
// module id = 750
// module chunks = 0